import React from "react";
import { Link, Typography } from "@common-ui/ui";
import CustomerTableEnum from "../../enums/CustomerTableEnum";
import checkTableValue from "../../utils/checkTableValue";
import { Edit } from "@mui/icons-material";
import { Table } from "../../components/Table/Table";
import { useHistory } from "react-router-dom";

function createData(props, router) {
  return {
    ...props,
    redirect: ({ row }) =>
      router.push({ pathname: `/customers/${row?.system_id}/${row?.org}` }),
    columns: [
      {
        field: "name",
        headerName: CustomerTableEnum.CUSTOMER,
        flex: 1,
        renderCell: (params) =>
          params.value ? (
            <Link
              href={`/customers/${params?.row?.system_id}/${params?.row?.org}`}
              underline="none"
            >
              <Typography sx={link}>{params?.value}</Typography>
            </Link>
          ) : (
            "---"
          ),
      },
      {
        field: "account",
        headerName: CustomerTableEnum.ACCOUNT_NUMBER,
        flex: 1,
        renderCell: (params) => checkTableValue(params?.value),
      },
      {
        field: "phone",
        headerName: CustomerTableEnum.PHONE,
        flex: 1,
        renderCell: (params) => checkTableValue(params?.value),
      },
      {
        field: "website",
        headerName: CustomerTableEnum.WEBSITE,
        flex: 1,
        renderCell: (params) => {
          return params?.value ? (
            <Link href={params?.value} target="_blank" underline="none">
              <Typography sx={link}>{params?.value}</Typography>
            </Link>
          ) : (
            "---"
          );
        },
      },
      {
        field: "system_id",
        headerName: "Actions",
        width: 100,
        renderCell: (params) => {
          return (
            <Edit
              onClick={() =>
                router.push({
                  pathname: `/customers/${params?.row?.system_id}/${params?.row?.org}`,
                })
              }
            />
          );
        },
      },
    ],
  };
}

export const CustomerTableView = (props) => {
  const router = useHistory();
  return <Table data={createData(props, router)} rowSize={props.rowSize} />;
};

const link = {
  color: "#2B7CD3 !important",
};
